import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'

export interface AuthCheckResponse extends Response {
	data: { userInfo: UserInfo }
}

export type UserInfo = {
	no: string
	username: string
	status: string
	role_no: string
	role: RoleType
	vendor_info: VendorInfoType
	create_date: string
	modify_date: string
	delete_date: string | null
}

export type RoleType = {
	no: string
	role: string
}

export type VendorInfoType = {
	no: number
	profile_img: string
}

export const checkAuth = async (): Promise<AuthCheckResponse> => {
	const response = await client.get<AuthCheckResponse>(`auth`)

	return response.data
}
